import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IUser } from 'src/app/core/interfaces/user.interface';
import { CasesService } from 'src/app/core/services/cases.service';
import { UnitsService } from 'src/app/core/services/units.service';
import { UserService } from 'src/app/core/services/user.service';
import { ICase } from 'src/app/modules/cases/interfaces/case.interface';
import { ICaseType } from 'src/app/modules/unit/interfaces/case-type.interface';

@Component({
  selector: 'app-assignment-modal',
  styleUrls: ['./assignment-modal.component.scss'],
  template: `
    <div class="content">
      <h2 class="title">Asignación del caso</h2>
      <mat-icon class="close-modal" (click)="onNoClick()">close</mat-icon>
      <div mat-dialog-content>
        <form [formGroup]="form" class="selectRasForms">
          <mat-form-field appearance="outline">
            <mat-label>Selecciona un Analista</mat-label>
            <mat-select formControlName="user">
              <mat-option *ngFor="let user of users" [value]="user._id">{{
                user.fullname
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </form>
      </div>
      <div mat-dialog-actions class="justify-content-center">
        <button mat-button mat-raised-button (click)="onNoClick()">Cancelar</button>
        <button
          mat-raised-button
          mat-button
          cdkFocusInitial
          (click)="assign(form.value)"
          color="primary"
        >
          Asignar
        </button>
      </div>
    </div>
  `,
})
export class AssignmentModalComponent {
  users: IUser[] = [];
  caseTypes: ICaseType[] = [];
  case: ICase;
  form: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<AssignmentModalComponent>,
    private readonly unitsService: UnitsService,
    public readonly userService: UserService,
    private readonly caseService: CasesService,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.case = data.case;
    this.getCaseTypes();
    this.form = this.fb.group({
      user: '',
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  getCaseTypes(): void {
    this.unitsService.getTypeCases(this.case.caseType.unit._id).subscribe({
      next: (caseTypes: any) => {
        this.caseTypes = caseTypes;
        this.case.caseType = caseTypes[0]._id;
        this.findUsers();
      },
    });
    this.caseTypes = [this.case.caseType];
  }

  async findUsers(): Promise<void> {
    let caseType = this.caseTypes.find(
      (item: any) => item._id == this.case.caseType
    );
    const roles = caseType.role;
    const users: IUser[] = [];

    for (const role of roles) {
      const usersByRole = await this.userService
        .getUsersByRole(role)
        .toPromise();
      users.push(...usersByRole);
    }

    this.users = users;
  }

  assign(value): void {
    console.log(value);
    this.caseService
      .update(this.case._id, {
        assigned: value.user,
        status: 'assigned',
        user_changing: this.userService.currentUser._id,
        toAssignedAt: new Date(),
      })
      .subscribe((response) => {
        console.log(response);
        this.dialogRef.close(true);
      });
  }
}
